<div class="cmps-cdk-d-flex cmps-cdk-cg-1 cmps-cdk-h-100pct">
    <cmps-report-builder-selection-section
        [noSelect]="noSelect"
        [selected]="step === _Step.DataSource"
        (click)="change.emit(_Step.DataSource)"
    >
        <ng-container class="cmps-report-builder-selection-section--name">
            View
        </ng-container>
        <ng-container class="cmps-report-builder-selection-section--selection">
            {{ viewParamLabels?.dataSourceLabel }}
        </ng-container>
    </cmps-report-builder-selection-section>
    <cmps-report-builder-selection-section
        [noSelect]="noSelect"
        [selected]="step === _Step.Date"
        (click)="change.emit(_Step.Date)"
    >
        <ng-container class="cmps-report-builder-selection-section--name">
            Date
        </ng-container>
        <ng-container class="cmps-report-builder-selection-section--selection">
            <div *ngIf="viewParamLabels?.periodTypeValueLabel != null">
                {{ 'Period Type' }} -
                {{ viewParamLabels?.periodTypeValueLabel }}
            </div>
            <div *ngIf="viewParamLabels?.dateRangeValueLabel != null">
                {{ 'Range' }} -
                {{ viewParamLabels?.dateRangeValueLabel }}
            </div>
        </ng-container>
    </cmps-report-builder-selection-section>
    <cmps-report-builder-selection-section
        [noSelect]="noSelect"
        [selected]="step === _Step.ReportType"
        (click)="change.emit(_Step.ReportType)"
    >
        <ng-container class="cmps-report-builder-selection-section--name">
            Report Type
        </ng-container>
        <ng-container class="cmps-report-builder-selection-section--selection">
            <ng-container *ngIf="viewParamLabels?.reportTypeLabel != null">
                {{ viewParamLabels?.reportTypeLabel }} -
                {{ viewParamLabels?.reportTypeValueLabel }}
            </ng-container>
        </ng-container>
    </cmps-report-builder-selection-section>
    <cmps-report-builder-selection-section
        [noSelect]="noSelect"
        [selected]="step === _Step.Dimensions"
        (click)="change.emit(_Step.Dimensions)"
    >
        <ng-container class="cmps-report-builder-selection-section--name">
            Dimensions
        </ng-container>
        <ng-container class="cmps-report-builder-selection-section--selection">
            <div *ngIf="viewParamLabels?.dataDimensionALabel != null">
                {{ viewParamLabels?.dataDimensionALabel }} -
                {{ viewParamLabels?.dataDimensionAValueLabel }}
            </div>
            <div *ngIf="viewParamLabels?.dataDimensionBLabel != null">
                {{ viewParamLabels?.dataDimensionBLabel }} -
                {{ viewParamLabels?.dataDimensionBValueLabel }}
            </div>
        </ng-container>
    </cmps-report-builder-selection-section>
    <cmps-report-builder-selection-section
        [noSelect]="noSelect"
        [selected]="step === _Step.Metrics"
        (click)="change.emit(_Step.Metrics)"
    >
        <ng-container class="cmps-report-builder-selection-section--name">
            Metrics
        </ng-container>
        <ng-container class="cmps-report-builder-selection-section--selection">
            <div class="cmps-cdk-max-w-768px">
                {{ viewParamLabels?.metricValueLabel }}
            </div>
        </ng-container>
    </cmps-report-builder-selection-section>
</div>
